import React, {useEffect, useState} from "react";


// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    CardBody,
    TabContent,
    Form, FormGroup, FormText,
    Row,
    Col,
    Label,
    Input
  } from "reactstrap";

import {store} from './utils/httpUtil';
import {logError, checkError} from './utils/helpers';
import {Blocks} from './constants/Blocks';
import {Countries} from './constants/Countries';  
import {ticketTypes} from './constants/TicketTypes';
import { useNavigate } from "react-router-dom";
import ActionLegend from './ActionLegend';
import { Link } from "react-router-dom";


function CheckInDetails({gId}) {

    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [alertColor, setAlertColor] = useState();
    const [alertMsg, setAlertMsg] = useState();
    const [guestId, setGuestId] = useState();

    const [details, setDetails] = useState({
      GuestName: "",
      TicketTypeIds: [],
      AllDocsVerified: false,
      RoomKeyReceived: false,
      WristBandReceived: false,
      IsCountryAmbassador: false, 
      CountryId: null,  
      BlockId: null,
      RoomNo: null
    });

    useEffect(() => { 

        if (sessionStorage.getItem('authenticated') === 'true'){

          setGuestId(gId);
          getGuestDetails(gId);

        } else {
            navigate("/", { replace: true });
        }
    }, [gId]);

    const getGuestDetails = async (guestId) => {
      return fetch("/apiCheckIn/" + guestId)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
            var data = result[0];

            console.log(data);  
            
            setDetails({  
              GuestName : data.guest_name,  
              TicketTypeIds: data.ticket_type_ids.split(", "),            
              AllDocsVerified: data.all_docs_verified,
              RoomKeyReceived: data.room_key_given,
              WristBandReceived: data.wrist_band_given,
              CountryId: data.country_id_passport, 
              IsCountryAmbassador: data.is_ambassador,  
              BlockId: data.block_id,
              RoomNo: data.room_no  
            });
      })
    }


    const updateCheckIn = async (e) => {

      e.preventDefault();

      if (details.AllDocsVerified === 0) {
        setAlertMsg("Please verify required documents before checking in.")
        setAlertColor("danger");
        setShowAlert(true);
        return;
      }
      
      const payload = {
          key: details.RoomKeyReceived,
          band: details.WristBandReceived
      };
      
      const response = await store("/apiCheckIn/" + guestId, JSON.stringify(payload))
      .then((response) => {
        if (response.status === 200) {
          setAlertMsg(details.GuestName + " saved successfully.");
          setAlertColor("success");
          setShowAlert(true);

          setTimeout(() => {
            document.getElementById("frmCheckIn").submit();
          }, 2000); // Delay of 3 seconds

        } else {
          setAlertMsg("Oops, there has been issue. Please try again.")
          setAlertColor("danger");
          setShowAlert(true);
        }
      })
      .catch((error) => {
        setAlertMsg(error.response.data.message)
        setAlertColor("danger");
        setShowAlert(true);
      });
    }

    const setColBG = (value) => {
        return ((value === 1 || value === true) ? 'bg-success'
          : 'bg-warning');
    }

    const setKeyClick = (value) => {
      setDetails({ ...details, RoomKeyReceived: value })
      setColBG(value);
    }

    const setBandClick = (value) => {
      setDetails({ ...details, WristBandReceived: value })
      setColBG(value);
    }

      
  return (
          <div className="wrapper">
              <div id="divCheckInDetails" className="divDetails">
                    <Col className="text-left" md="10">
                        <h5 className="description">
                              <Card>
                                    <CardHeader>{details.GuestName}
                                      {details.IsCountryAmbassador ? <span style={{color:'steelblue', marginLeft:'10px'}}>(CA: {Countries[details.CountryId]})</span> : null}
                                    </CardHeader>
                                    <CardBody>
                                      <Row>
                                          <Col md={10}>  
                                            {details.TicketTypeIds.map((guestTicketType, index) => (
                                                <div className="divTicketTypes" key={index}>{ticketTypes[guestTicketType]}</div>
                                            ))}
                                                <TabContent className="text-left">                                       
                                                    <Form id="frmCheckIn" onSubmit={(e) => updateCheckIn(e)}>
                                                        <Alert isOpen={showAlert} color={alertColor}>
                                                          {alertMsg}
                                                        </Alert>
                                                        {details.BlockId === null ? null :
                                                        (
                                                          <Row>
                                                              <Col md={5}>
                                                                  <Label>Block: <b>{Blocks[details.BlockId]}</b></Label><br/>
                                                                  <Label>Room No: <b>{details.RoomNo}</b></Label>
                                                              </Col>
                                                          </Row>
                                                        )}  
                                                          <Row style={{margin:'0'}}>
                                                                <Col md={3} className={setColBG(details.AllDocsVerified)}>                                                          
                                                                      <FormGroup check>    
                                                                        <Label>  
                                                                            <Link style={{ textDecoration:'underline', color:'blue'}} to={`/docDetails/?gId=${guestId}`} target="_blank" rel="noopener noreferrer">
                                                                              Documents
                                                                            </Link>                                                                                                                     
                                                                        </Label>
                                                                        </FormGroup>                                                        
                                                                </Col>
                                                                <Col md={3} className={setColBG(details.RoomKeyReceived)}>  
                                                                      <FormGroup check> 
                                                                        <Input type="checkbox" id="chkKey" checked={details.RoomKeyReceived} onChange={(e) => setKeyClick(e.target.checked)} /> 
                                                                            {' '}
                                                                        <Label check>
                                                                          Key
                                                                        </Label>
                                                                      </FormGroup>
                                                                </Col> 
                                                                <Col md={3} className={setColBG(details.WristBandReceived)}> 
                                                                      <FormGroup check> 
                                                                        <Input type="checkbox" id="chkBand" checked={details.WristBandReceived}  onChange={(e) => setBandClick(e.target.checked)} /> 
                                                                            {' '}
                                                                        <Label check>
                                                                          Band
                                                                        </Label>
                                                                      </FormGroup>
                                                                </Col>        
                                                          </Row>
                                                          <Row>
                                                              <Col md={10}>
                                                                      <Button color="primary" type="submit">
                                                                      Save
                                                                      </Button>
                                                                  <br/> 
                                                              </Col>
                                                          </Row>
                                                    </Form>
                                                </TabContent>
                                          </Col>
                                      </Row>  
                                    </CardBody>
                              </Card>
                        </h5>
                  </Col>
              </div>
        </div>
  );                                                                                            
}

export default CheckInDetails;
